import React, { memo } from 'react';

import { useMenus } from 'react/hooks/sidebar.hook';
import MenuItem from './MenuItem';

function MenusContainer() {
  const { menus } = useMenus();

  return (
    <div className="menus-container">
      <ul>
        {menus.map(({ id, active, name, submenus }) => (
          <MenuItem 
            key={id} 
            id={id}
            active={active}
            name={name}
            submenus={submenus}
          />
        ))}
      </ul>
    </div>
  );
}

export default memo(MenusContainer);
